import React from 'react';

import locations from '../constants/locations';

const countryMap = {
  uk: 'United Kingdom',
  au: 'Australia',
};

const getArea = (country, areaLevel1, areaLevel2) => {
  if (!country) {
    return '';
  }
  if (!areaLevel1) {
    return countryMap[country];
  }
  const level1 = areaLevel1
    ? locations[country].filter(area => area.value === areaLevel1)[0].label
    : '';
  if (!areaLevel2) {
    return level1;
  }
  const level2 = areaLevel2
    ? locations[country]
        .filter(area => area.value === areaLevel1)[0]
        .children.filter(area => area.value === areaLevel2)[0].label
    : '';
  return `${level2}, ${level1}`;
};

export default function Location({
  areaLevel1 = false,
  areaLevel2 = false,
  country = false,
}) {
  return <div>{getArea(country, areaLevel1, areaLevel2)}</div>;
}
